import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M.523 12.675a1.35 1.35 0 0 1 0-1.35L5.677 2.4a1.35 1.35 0 0 1 1.17-.675h10.306c.483 0 .928.257 1.17.675l5.153 8.926a1.35 1.35 0 0 1 0 1.35l-5.154 8.926a1.35 1.35 0 0 1-1.169.675H6.846a1.35 1.35 0 0 1-1.169-.675zm6.41 8.101h10.134L22.134 12l-5.067-8.776H6.933L1.866 12zM12 7.25a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0V8a.75.75 0 0 1 .75-.75m.568 9.25a.75.75 0 0 0-1.115-1.003l-.01.011a.75.75 0 0 0 1.114 1.004z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }